import React from 'react';
import { TablePagination, SxProps, Theme } from '@mui/material';
import { PAGINATION_CONFIG } from 'utils/paginationConfig';

interface StandardTablePaginationProps {
  count: number;
  page: number;
  onPageChange: (event: unknown, newPage: number) => void;
  rowsPerPage: number;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps<Theme>;
  component?: React.ElementType;
}

/**
 * Standardized TablePagination component with consistent pagination options
 * Uses default page size of 100 and options: [5, 10, 15, 20, 50, 100]
 */
export const StandardTablePagination: React.FC<StandardTablePaginationProps> = ({
  count,
  page,
  onPageChange,
  rowsPerPage,
  onRowsPerPageChange,
  sx,
  component = 'div',
}) => {
  return (
    <TablePagination
      component={component}
      count={count}
      page={page}
      onPageChange={onPageChange}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={onRowsPerPageChange}
      rowsPerPageOptions={PAGINATION_CONFIG.PAGE_SIZE_OPTIONS}
      sx={sx}
    />
  );
};
